// src/components/Footer.js - Updated for ShowingBooker branding
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #f8f9fa;
  padding: 20px 0;
  margin-top: 40px;
  border-top: 1px solid #eee;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  
  a {
    color: #333;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;


const Copyright = styled.p`
  font-size: 0.9rem;
  color: #666;
`;

const Footer = () => {

  return (
    <FooterContainer>
      <FooterContent>
        <FooterLinks>
          <Link to="/tenant-rights">Tenants</Link>
          <Link to="/agent-liability">Agents</Link>
          <Link to="/owner-protection">Owners</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/contact">Contact</Link>
        </FooterLinks>
        
        
        <Copyright>
          © {new Date().getFullYear()} ShowingBooker.com | ShowingBooker LLC, 26565 Agoura Road, Suite 200, Calabasas, CA 91302 USA | Tech Support: hello@showingbooker.com
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;